import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  messageService = inject(MessageService);
  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/token')) {
      // Não adiciona o token aos headers
      return handler.handle(req);
    }

    const userCredentials = JSON.parse(String(localStorage.getItem('hubapi-web-user-credential')));
    if (!userCredentials) {
      setTimeout(() => {
        this.messageService.add({
          key: 'tl',
          severity: 'error',
          summary: 'Usuário não autenticado!',
          detail: 'O sistema redirecionará para tela de login',
        });

        window.location.href = getRedirectLoginUrl();
      }, 10000);
    }
    const authReq = req.clone({
      headers: req.headers
        .set('Authorization', `${userCredentials['token_type']} ${userCredentials['access_token']}`)
        .set('Access-Control-Allow-Origin', '*'), // Clona a requisição com o cabeçalho de autorização
    });

    return handler.handle(authReq).pipe(
      tap({
        error: err => {
          if (err.status == 0) {
            this.messageService.add({
              key: 'tl',
              severity: 'error',
              summary: 'Sessão expirada!',
              detail: 'O sistema redirecionará para tela de login',
            });
            window.location.href = getRedirectLoginUrl();
          }
        },
      })
    );
  }
}
const getRedirectLoginUrl = () => {
  return `${environment.azureBaseUrl
    .replace(':tenant', environment.tenant)
    .replace(':tenant', environment.tenant)}/authorize?p=${environment.azurePolicy}&client_id=${
    environment.azureClientId
  }&nonce=defaultNonce&redirect_uri=${window.origin}&scope=openid ${environment.scope}&response_type=code&prompt=login`;
};
